// extracted by mini-css-extract-plugin
export default {"primaryColorBase":"#ed7204","primaryColorLight":"#f57f16","primaryColorLighter":"#f0a867","primaryColorLightest":"#f4d0af"};